module.exports = __webpack_public_path__ + "images/vangent_small6d1c6fb4e3f30ceead4006de593f43ac.png";